<template>
  <b-overlay :show="processing" rounded="sm" class="overlay-display">
    <template #overlay>
      <div class="text-center">
        <b-spinner type="grow" variant="info" label="Loading..."></b-spinner>
        <p id="cancel-label">{{ processingMessage }}</p>
      </div>
    </template>
    <b-col lg="6" class="my-1">
      <b-button class="actionbutton" @click="addItem">New Schedule</b-button>
      <b-form-group
        label="Filter"
        label-for="filter-input"
        label-cols-sm="3"
        label-align-sm="right"
        label-size="sm"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filter-input"
            v-model="filter"
            type="search"
            placeholder="Type to Search"
          ></b-form-input>

          <b-input-group-append>
            <b-icon icon="search" class="icon"></b-icon>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-table
      hover
      :items="items"
      :fields="fields"
      :filter-included-fields="filterOn"
      :filter="filter"
      @filtered="onFiltered"
      show-empty
      small
    >
      <template #cell(actions)="row">
        <div class="btnContainer">
          <b-button size="sm" @click="editItem(row.item)" class="actionbutton">
            Update
          </b-button>

          <b-button
            size="sm"
            @click="enableItem(row.item)"
            v-if="row.item.state == 'DISABLED'"
            class="actionbutton"
          >
            Enable
          </b-button>
          <b-button
            size="sm"
            @click="disableItem(row.item)"
            v-if="row.item.state == 'ENABLED'"
            class="actionbutton mr-1"
          >
            Disable
          </b-button>
        </div>
      </template>
    </b-table>
  </b-overlay>
</template>
<script>
export default {
  data() {
    return {
      processingMessage: "Please wait...",
      fields: [
        {
          key: "name",
          sortable: true,
          label: "Schedule Name"
        },
        {
          key: "reportName",
          sortable: true,
          label: "Report Name"
        },
        {
          key: "state",
          sortable: true,
          label: "State"
        },
        {
          key: "description",
          sortable: true,
          label: "Description"
        },
        {
          key: "scheduleExpression",
          sortable: true,
          label: "Schedule Expression"
        },
        {
          key: "scheduleExpressionTimezone",
          sortable: true,
          label: "Schedule Timezone"
        },
        { key: "actions", label: "Actions" }
      ],
      items: [],
      reports: [],
      filter: null,
      filterOn: [],
      totalRows: 1,
      commentText: [],
      sortDirection: "asc"
    };
  },
  async created() {
    this.load();
  },
  methods: {
    async load() {
      this.processing = true;
      try {
        // Fetch both schedules and reports data
        const [schedulesResponse, reportsResponse] = await Promise.all([
          this.axios.get(
            process.env.VUE_APP_API_ADMIN_API_ENDPOINT + "/order-pull/schedules"
          ),
          this.axios.get(
            process.env.VUE_APP_API_ADMIN_API_ENDPOINT + "/order-pull/config"
          )
        ]);

        if (schedulesResponse && schedulesResponse.status === 200) {
          const schedules = schedulesResponse.data || [];
          const reports = reportsResponse.data || [];

          // Create a map of reports by UUID for quick lookup
          const reportsMap = {};
          reports.forEach(report => {
            reportsMap[report.id] = report;
          });

          // Enhance schedules with report names
          this.items = schedules.map(schedule => {
            let reportName = "N/A";
            if (
              schedule.input &&
              schedule.input.uuid &&
              reportsMap[schedule.input.uuid]
            ) {
              reportName = reportsMap[schedule.input.uuid].reportName || "N/A";
            }

            return {
              ...schedule,
              reportName: reportName
            };
          });

          this.reports = reports;
        } else {
          console.log("Response is not 200");
        }
      } catch (error) {
        console.error("Error: ", error);
        let message;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          message = error.response.data.message;
        } else {
          if (error.message === "Network Error") {
            message = error.message + ": Please try again later";
          } else {
            message = "Response Error";
          }
        }
        this.displayMessage("warning", message);
      } finally {
        this.processing = false;
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    editItem(item) {
      this.$router.push({
        name: "SchedulesConfig",
        params: { editedItem: item }
      });
    },

    addItem() {
      this.$router.push({
        name: "SchedulesConfig",
        params: {}
      });
    },

    enableItem(item) {
      if (confirm("Are you sure you want to enable this item?")) {
        this.processing = true;
        const params = {
          type: "enable",
          name: item.name
        };
        this.axios
          .put(
            process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
              "/order-pull/schedules",
            params
          )
          .then(response => {
            this.items = [];
            this.load();
            this.processing = false;
          });
      }
    },

    disableItem(item) {
      if (confirm("Are you sure you want to disable this item?")) {
        this.processing = true;
        const params = {
          type: "disable",
          name: item.name
        };
        this.axios
          .put(
            process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
              "/order-pull/schedules",
            params
          )
          .then(response => {
            this.items = [];
            this.load();
            this.processing = false;
          });
      }
    },
    displayMessage(messageType, messageBody) {
      this.$bvToast.toast("Empty Body", {
        title: messageBody,
        variant: messageType,
        headerClass: "py-2 px-4",
        bodyClass: "d-none",
        autoHideDelay: 5000,
        solid: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/order-rules-grid.scss";
</style>
